"use client";
// components/TawkTo.js
// import { useEffect } from "react";

// const TawkTo = () => {
//   useEffect(() => {
//     const tawkToScript = document.createElement("script");
//     tawkToScript.async = true;
//     tawkToScript.src =
//       "https://embed.tawk.to/65f195c19131ed19d9797359/1horr1v7u";
//     tawkToScript.charset = "UTF-8";
//     tawkToScript.setAttribute("crossorigin", "*");

//     document.head.appendChild(tawkToScript);

//     return () => {
//       document.head.removeChild(tawkToScript);
//     };
//   }, []);

//   return null;
// };

// export default TawkTo;

// components/CustomWidget.js
import React, { useEffect } from "react";
import CallIcon from "@/app/images/header/call-icon.svg";
import Image from "next/image";
import { FaCalendarAlt } from "react-icons/fa";

const TawkTo = () => {
  useEffect(() => {
    // Custom widget setup code can go here if needed
  }, []);

  return (
    <div style={styles.widgetContainer}>
      <div
        style={styles.widgetContent}
        className="bg-[#d5af34] ccc h-[65px] w-[65px] rounded-full "
      >
        <a
          href="/booking"
          className="bg-[#d5af34] h-[65px] w-[65px] flex justify-center items-center rounded-full"
          aria-label="Book your appointment"
        >
          <FaCalendarAlt
            style={{ fontSize: "30px" }}
            className="text-white"
            aria-hidden="true"
          />
        </a>
      </div>
    </div>
  );
};

const styles = {
  widgetContainer: {
    position: "fixed",
    bottom: "20px",
    zIndex: 1000,
    borderRadius: "10px",
    padding: "10px",
  },
  widgetContent: {
    color: "#333",
    fontSize: "40px",
    fontFamily: "Arial, sans-serif",
  },
};
export default TawkTo;
